export default __webpack_public_path__ + "static/caramel-eyelet-banner-mobile-0ee7e320ec2a161b8899784ed8059946.webp";